exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-17c2359d]{font-size:2rem;color:#4993d2;margin-left:1rem}.default-container[data-v-17c2359d]{padding:2rem;border:none!important}.lvl-1[data-v-17c2359d]{margin-left:.5rem}.lvl-2[data-v-17c2359d]{margin-left:1.5rem}.lvl-3[data-v-17c2359d]{margin-left:2.5rem}#badge[data-v-17c2359d]{content:\"\";font-size:5px;padding:1px 4px;border-radius:100%;margin-right:.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-17c2359d","scoped":true,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/forms/natfin-list.vue
// module id = 1663
// module chunks = 0